import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';

import authReducer from './auth/authSlice';
import fmnParseReducer from './fmnParse/fmnParseSlice';
import globalReducer from './global/globalSlice';
import ipenNotaryReducer from './ipenNotary/ipenNotarySlice';
import ipenSessionReducer from './ipenSession/ipenSessionSlice';
import notificationsReducer from './notifications/notificationsSlice';
import ordersReducer from './orders/ordersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    global: globalReducer,
    orders: ordersReducer,
    notifications: notificationsReducer,
    fmnParse: fmnParseReducer,
    ipenSession: ipenSessionReducer,
    ipenNotary: ipenNotaryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['notifications/enqueueSnackbar'],
        // // Ignore these field paths in all actions
        // ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        // // Ignore these paths in the state
        ignoredPaths: ['notifications.notifications'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
